// import React from 'react';

import SomeJavaScriptInterviewTasks from './blogData/SomeJavaScriptInterviewTasks';
import SomeJavaScriptProblemsSolution from './blogData/SomeJavaScriptProblemsSolution';
import SomeReactInterviewQuestions from './blogData/SomeReactInterviewQuestions';
import SomeJavaScriptInterviewQuestions2 from './blogData/SomeJavaScriptInterviewQuestions2';
import SomeJavaScriptInterviewQuestions from './blogData/SomeJavaScriptInterviewQuestions';
import SomeHTMLAndCSSInterviewQuestions from './blogData/SomeHTMLAndCSSInterviewQuestions';
import JavaScriptAlgorithm from './blogData/JavaScriptAlgorithm';
import JavaScriptDataStructure from './blogData/JavaScriptDataStructure';
import TenThingsInReactThatWeShouldKnow from './blogData/TenThingsInReactThatWeShouldKnow';
import ReactHooks from './blogData/ReactHooks';
import ReactJSXPropsError from './blogData/ReactJSXPropsError';
import ReactJSIntroAndBehindTheScene from './blogData/ReactJSIntroAndBehindTheScene';
import JavaScriptClasses from './blogData/JavaScriptClasses';
import JavaScriptObjectOrientedProgramming from './blogData/JavaScriptObjectOrientedProgramming';
import MostJavaScriptNewFeatureInES6 from './blogData/MostJavaScriptNewFeatureInES6';
import JavaScriptOperatorsFunctionsNullAndUndefinedTips from './blogData/JavaScriptOperatorsFunctionsNullAndUndefinedTips';
import TenThingsEveryWebDeveloperShouldKnow from './blogData/TenThingsEveryWebDeveloperShouldKnow';
import CrossBrowserProblemsAndSolution from './blogData/CrossBrowserProblemsAndSolution';
import IntroductionToJavaScript from './blogData/IntroductionToJavaScript';
import SomeMostUsedJavaScriptStringNumberArrayAndObject from './blogData/SomeMostUsedJavaScriptStringNumberArrayAndObject';
import CompleteReactAppDeployOrHostInFirebase from './blogData/CompleteReactAppDeployOrHostInFirebase';

const blogData = [
    // { id: 22, permalink: "permalink", thumb: "Thumbnail", postBy: "Wasek Bellah", postDate: "May 17, 2020", categories: "React", title: "Title", shortDesc: "Short", fullDesc: "Full" },

    SomeJavaScriptInterviewTasks,
    SomeJavaScriptProblemsSolution,
    SomeReactInterviewQuestions,
    SomeJavaScriptInterviewQuestions2,
    SomeJavaScriptInterviewQuestions,
    SomeHTMLAndCSSInterviewQuestions,
    JavaScriptAlgorithm,
    JavaScriptDataStructure,
    TenThingsInReactThatWeShouldKnow,
    ReactHooks,
    ReactJSXPropsError,
    ReactJSIntroAndBehindTheScene,
    JavaScriptClasses,
    JavaScriptObjectOrientedProgramming,
    MostJavaScriptNewFeatureInES6,
    JavaScriptOperatorsFunctionsNullAndUndefinedTips,
    TenThingsEveryWebDeveloperShouldKnow,
    CrossBrowserProblemsAndSolution,
    IntroductionToJavaScript,
    SomeMostUsedJavaScriptStringNumberArrayAndObject,
    CompleteReactAppDeployOrHostInFirebase
];
export default blogData;